import { w3cwebsocket as W3CWebSocket } from "websocket";
import LZString from "lz-string";

import { constHostAddressConfig } from './constData';

import { ProcessMsgIndustries, ProcessMsgCurrentTime, ProcessMsgSysParam, ProcessMsgConcurrent, ProcessMsgMarket } from "./processMsgSharedHelper";
import { ClearAllStockChart, ProcessMsgStock, ProcessMsgStockMatchChart, ProcessMsgStockPriceChart, ProcessMsgStockClosePriceHistChart, ProcessMsgStockForeignTradeHistChart, ProcessMsgStockPutThrough, ProcessMsgStockTPRL } from './processMsgStockHelper';
import { ClearAllIndexChart, ProcessMsgIndex, ProcessMsgIndex30Symbol, ProcessMsgIndexChart, ProcessMsgIndexStatisticChart, ProcessMsgIndexForeignTradeHistChart } from './processMsgIndexHelper';
import { processMsgMarketTPRL } from "./processMsgBoardMarketHelper";

export const wsMsgType = {
    Res_SysParam: 99,
    Res_Concurrent: 98,
    Res_CurrentTime: 1,
    Res_PriceBoardStock: 2,
    Res_PriceBoardIndex: 3,
    Res_InitStock: 4,
    Res_InitIndex: 5,
    Res_StockMatchChart: 6,
    Res_StockPriceChart: 7,
    Res_IndexChart: 8,
    Res_Index30Symbol: 9,
    Res_InitData: 10,
    Res_IndustryData: 11,

    Res_StockClosePriceHistChart: 12,
    Res_StockForeignTradeHistChart: 13,

    Res_IndexStatisticChart: 14,
    Res_StockPutThrough: 15,
    Res_IndexForeignTradeHistChart: 16,

    Res_InitMarket: 17,
    Res_PriceBoardMarket: 18,

    //TPRL
    Res_StockTPRLInit: 19,
    Res_StockTPRLChange: 20,

    //Message thông tin bảng của trái phiếu riêng ler
    Res_BoardTPRLInit: 21,
    Res_BoardTPRLChange: 22,

    //Message thông tin thay đổi của thị trường TPRL
    Res_MarketTPRLChange: 24,

    // Req Types
    Req_CurrentTime: 1,
    Req_InitStock: 2,
    Req_InitIndex: 3,
    Req_InitData: 4,
}

export const wsMsgSeparatorChar = {
    DataSeparatorChar: "*",
    PropSeparatorChar: "|",
    ObjectSeparatorChar: "$",
}

const wsReadyState = {
    CONNECTING: 0,
    OPEN: 1,
    CLOSING: 2,
    CLOSED: 3,
};

let wsClient = null;

const connectWS = () => {
    if (wsClient === null || wsClient.readyState === wsReadyState.CLOSED) {
        wsClient = new W3CWebSocket(constHostAddressConfig.WSHostAddress);

        wsClient.onopen = () => {
            console.log("WS Connected-", new Date());
            sendMessage(JSON.stringify({ msgType: wsMsgType.Req_InitData }));
            sendMessage(JSON.stringify({ msgType: wsMsgType.Req_InitStock }));
            sendMessage(JSON.stringify({ msgType: wsMsgType.Req_InitIndex }));
        };
        wsClient.onmessage = (evt) => {
            // console.log(evt.data);
            OnReceiveMessage(evt.data);
        };
        wsClient.onerror = (evt) => {
            console.log(evt);
        };
        wsClient.onclose = (message) => {
            console.log("WS Disconnected-", new Date());
            connectWS();
        };
    }
};

connectWS();

export const sendMessage = (message) => {
    if (wsClient && wsClient.readyState === wsReadyState.OPEN) {
        wsClient.send(message);
    } else {
        console.log("WS not opened");
    }
};

// Xu ly msg nhan dc
const OnReceiveMessage = (rawMessage) => {
    // console.log(rawMessage, "rawMessage");
    try {
        let msg = JSON.parse(LZString.decompressFromBase64(rawMessage));
        //
        if (msg) {
            if (msg.msgType === wsMsgType.Res_CurrentTime) {
                ProcessMsgCurrentTime(msg.message)
            }
            else if (msg.msgType === wsMsgType.Res_SysParam) {
                ProcessMsgSysParam(msg.message)
            }
            else if (msg.msgType === wsMsgType.Res_Concurrent) {
                ProcessMsgConcurrent(msg.message)
            }
            else if (msg.msgType === wsMsgType.Res_IndustryData) {
                ProcessMsgIndustries(msg.message);
            }
            else if (msg.msgType === wsMsgType.Res_InitStock) {
                // Clear all chart data
                ClearAllStockChart();
                //
                ProcessMsgStock(msg.message, true);
            }
            else if (msg.msgType === wsMsgType.Res_PriceBoardStock) {
                ProcessMsgStock(msg.message);
            }
            else if (msg.msgType === wsMsgType.Res_StockMatchChart) {
                ProcessMsgStockMatchChart(msg.message);
            }
            else if (msg.msgType === wsMsgType.Res_StockPriceChart) {
                ProcessMsgStockPriceChart(msg.message);
            }
            else if (msg.msgType === wsMsgType.Res_StockClosePriceHistChart) {
                ProcessMsgStockClosePriceHistChart(msg.message);
            }
            else if (msg.msgType === wsMsgType.Res_StockForeignTradeHistChart) {
                ProcessMsgStockForeignTradeHistChart(msg.message);
            }
            else if (msg.msgType === wsMsgType.Res_StockPutThrough) {
                ProcessMsgStockPutThrough(msg.message);
            }
            //
            else if (msg.msgType === wsMsgType.Res_InitIndex) {
                // Clear all chart data
                ClearAllIndexChart();
                //
                ProcessMsgIndex(msg.message, true);
            }
            else if (msg.msgType === wsMsgType.Res_IndexChart) {
                ProcessMsgIndexChart(msg.message);
            }
            else if (msg.msgType === wsMsgType.Res_PriceBoardIndex) {
                ProcessMsgIndex(msg.message);
            }
            else if (msg.msgType === wsMsgType.Res_Index30Symbol) {
                ProcessMsgIndex30Symbol(msg.message);
            }
            else if (msg.msgType === wsMsgType.Res_IndexStatisticChart) {
                ProcessMsgIndexStatisticChart(msg.message);
            }
            else if (msg.msgType === wsMsgType.Res_IndexForeignTradeHistChart) {
                ProcessMsgIndexForeignTradeHistChart(msg.message);
            }
            // Market
            else if (msg.msgType === wsMsgType.Res_InitMarket) {
                ProcessMsgMarket(msg.message, true);
            }
            else if (msg.msgType === wsMsgType.Res_PriceBoardMarket) {
                ProcessMsgMarket(msg.message, false);
            }
            //TPRL
            else if (msg.msgType === wsMsgType.Res_StockTPRLInit) {
                ProcessMsgStockTPRL(msg.message, true);
            }
            else if (msg.msgType === wsMsgType.Res_StockTPRLChange) {
                ProcessMsgStockTPRL(msg.message, false);
            }
            else if (msg.msgType === wsMsgType.Res_MarketTPRLChange) {
                processMsgMarketTPRL(msg.message, true);
            }
        }
    }
    catch (e) {
        console.log(e);
    }
};
